import { Injectable } from "@angular/core";
import { ViolationCategory } from "../types/Violation/ViolationCategory";
import { ClientService } from "../services/client.service";
import { ArrayClientRepository } from "./abstract/array.client.repository";

@Injectable({
  providedIn: "root",
})
export class IrefCategoriesRepository extends ArrayClientRepository<ViolationCategory> {
  constructor(clientService: ClientService) {
    super(clientService, "schemas.schCFG_IREF_Category.records", "categoryID");
  }

  public getIrefCategoriesByInspectionTypeID(
    inspectionTypeID: string,
  ): ViolationCategory[] {
    return super.getFilteredByValue("inspectionTypeID", inspectionTypeID);
  }
}
